export interface MedicineSuggestion {
  brand: string;
  generic: string;
  strength: string;
}

export const medicineDb: MedicineSuggestion[] = [
  { brand: "Napa", generic: "Paracetamol", strength: "500mg" },
  { brand: "Napa Extra", generic: "Paracetamol + Caffeine", strength: "500mg/65mg" },
  { brand: "Ace", generic: "Paracetamol", strength: "500mg" },
  { brand: "Tylenol", generic: "Paracetamol", strength: "500mg" },
  { brand: "Panadol", generic: "Paracetamol", strength: "500mg" },
  { brand: "Renova", generic: "Paracetamol", strength: "500mg" },
  { brand: "Seclo", generic: "Omeprazole", strength: "20mg" },
  { brand: "Losectil", generic: "Omeprazole", strength: "20mg" },
  { brand: "Omedon", generic: "Omeprazole", strength: "20mg" },
  { brand: "Omep", generic: "Omeprazole", strength: "20mg" },
  { brand: "Protop", generic: "Pantoprazole", strength: "40mg" },
  { brand: "Pantop", generic: "Pantoprazole", strength: "40mg" },
  { brand: "Panto", generic: "Pantoprazole", strength: "40mg" },
  { brand: "Nexum", generic: "Esomeprazole", strength: "20mg" },
  { brand: "Esoral", generic: "Esomeprazole", strength: "20mg" },
  { brand: "Nexium", generic: "Esomeprazole", strength: "40mg" },
  { brand: "Glucomin", generic: "Metformin", strength: "500mg" },
  { brand: "Glucomet", generic: "Metformin", strength: "500mg" },
  { brand: "Metformin", generic: "Metformin", strength: "500mg" },
  { brand: "Diamet", generic: "Metformin", strength: "850mg" },
  { brand: "Amaryl", generic: "Glimepiride", strength: "2mg" },
  { brand: "Glimy", generic: "Glimepiride", strength: "1mg" },
  { brand: "Glimepil", generic: "Glimepiride", strength: "2mg" },
  { brand: "Glimpid", generic: "Glimepiride", strength: "2mg" },
  { brand: "Glucovance", generic: "Metformin + Glibenclamide", strength: "500mg/5mg" },
  { brand: "Januvia", generic: "Sitagliptin", strength: "100mg" },
  { brand: "Xelevia", generic: "Sitagliptin", strength: "100mg" },
  { brand: "Amdocal", generic: "Amlodipine", strength: "5mg" },
  { brand: "Norvasc", generic: "Amlodipine", strength: "5mg" },
  { brand: "Amlocard", generic: "Amlodipine", strength: "5mg" },
  { brand: "Amcard", generic: "Amlodipine", strength: "5mg" },
  { brand: "Losar", generic: "Losartan", strength: "50mg" },
  { brand: "Losacar", generic: "Losartan", strength: "50mg" },
  { brand: "Lozar", generic: "Losartan", strength: "50mg" },
  { brand: "Betaloc", generic: "Metoprolol", strength: "50mg" },
  { brand: "Metpro", generic: "Metoprolol", strength: "50mg" },
  { brand: "Lopressor", generic: "Metoprolol", strength: "50mg" },
  { brand: "Clopid", generic: "Clopidogrel", strength: "75mg" },
  { brand: "Plavix", generic: "Clopidogrel", strength: "75mg" },
  { brand: "Plagrel", generic: "Clopidogrel", strength: "75mg" },
  { brand: "Ecosprin", generic: "Aspirin", strength: "75mg" },
  { brand: "Aspirin", generic: "Aspirin", strength: "75mg" },
  { brand: "Cardiorin", generic: "Aspirin", strength: "75mg" },
  { brand: "Lisinopril", generic: "Lisinopril", strength: "5mg" },
  { brand: "Lisril", generic: "Lisinopril", strength: "5mg" },
  { brand: "Atorin", generic: "Atorvastatin", strength: "10mg" },
  { brand: "Lipitor", generic: "Atorvastatin", strength: "10mg" },
  { brand: "Ator", generic: "Atorvastatin", strength: "10mg" },
  { brand: "Atova", generic: "Atorvastatin", strength: "20mg" },
  { brand: "Rosutin", generic: "Rosuvastatin", strength: "10mg" },
  { brand: "Crestor", generic: "Rosuvastatin", strength: "10mg" },
  { brand: "Moxacil", generic: "Amoxicillin", strength: "500mg" },
  { brand: "Amoxil", generic: "Amoxicillin", strength: "500mg" },
  { brand: "Amoxin", generic: "Amoxicillin", strength: "500mg" },
  { brand: "Amoxiclav", generic: "Amoxicillin + Clavulanic Acid", strength: "500mg/125mg" },
  { brand: "Augmentin", generic: "Amoxicillin + Clavulanic Acid", strength: "500mg/125mg" },
  { brand: "Cipro", generic: "Ciprofloxacin", strength: "500mg" },
  { brand: "Ciprocin", generic: "Ciprofloxacin", strength: "500mg" },
  { brand: "Ciproflox", generic: "Ciprofloxacin", strength: "500mg" },
  { brand: "Azit", generic: "Azithromycin", strength: "500mg" },
  { brand: "Zithrox", generic: "Azithromycin", strength: "500mg" },
  { brand: "Zimax", generic: "Azithromycin", strength: "500mg" },
  { brand: "Azithrocin", generic: "Azithromycin", strength: "250mg" },
  { brand: "Zithromax", generic: "Azithromycin", strength: "500mg" },
  { brand: "Neocef", generic: "Cefixime", strength: "200mg" },
  { brand: "Cefim", generic: "Cefixime", strength: "200mg" },
  { brand: "Cef3", generic: "Cefixime", strength: "200mg" },
  { brand: "Suprax", generic: "Cefixime", strength: "200mg" },
  { brand: "Doxycap", generic: "Doxycycline", strength: "100mg" },
  { brand: "Doxin", generic: "Doxycycline", strength: "100mg" },
  { brand: "Vibramycin", generic: "Doxycycline", strength: "100mg" },
  { brand: "Filmet", generic: "Metronidazole", strength: "400mg" },
  { brand: "Metro", generic: "Metronidazole", strength: "400mg" },
  { brand: "Flagyl", generic: "Metronidazole", strength: "400mg" },
  { brand: "Alatrol", generic: "Cetirizine", strength: "10mg" },
  { brand: "Cetigen", generic: "Cetirizine", strength: "10mg" },
  { brand: "Zyrtec", generic: "Cetirizine", strength: "10mg" },
  { brand: "Fenadin", generic: "Fexofenadine", strength: "120mg" },
  { brand: "Fexo", generic: "Fexofenadine", strength: "120mg" },
  { brand: "Allegra", generic: "Fexofenadine", strength: "120mg" },
  { brand: "Histacin", generic: "Chlorpheniramine", strength: "4mg" },
  { brand: "Piriton", generic: "Chlorpheniramine", strength: "4mg" },
  { brand: "Ponstan", generic: "Mefenamic Acid", strength: "500mg" },
  { brand: "Mefenamic", generic: "Mefenamic Acid", strength: "500mg" },
  { brand: "Profen", generic: "Ibuprofen", strength: "400mg" },
  { brand: "Brufen", generic: "Ibuprofen", strength: "400mg" },
  { brand: "Nurofen", generic: "Ibuprofen", strength: "400mg" },
  { brand: "Voltaren", generic: "Diclofenac", strength: "50mg" },
  { brand: "Diclofen", generic: "Diclofenac", strength: "50mg" },
  { brand: "Voltarene", generic: "Diclofenac", strength: "75mg" },
  { brand: "Lasix", generic: "Furosemide", strength: "40mg" },
  { brand: "Frusamide", generic: "Furosemide", strength: "40mg" },
  { brand: "Torsid", generic: "Torsemide", strength: "10mg" },
  { brand: "Aldactone", generic: "Spironolactone", strength: "25mg" },
  { brand: "Spiro", generic: "Spironolactone", strength: "25mg" },
  { brand: "Rivo", generic: "Clonazepam", strength: "0.5mg" },
  { brand: "Clonaz", generic: "Clonazepam", strength: "0.5mg" },
  { brand: "Xanax", generic: "Alprazolam", strength: "0.25mg" },
  { brand: "Sedil", generic: "Alprazolam", strength: "0.5mg" },
  { brand: "Prednol", generic: "Prednisolone", strength: "5mg" },
  { brand: "Pred", generic: "Prednisolone", strength: "5mg" },
  { brand: "Dexason", generic: "Dexamethasone", strength: "0.5mg" },
  { brand: "Decadron", generic: "Dexamethasone", strength: "0.5mg" },
  { brand: "Vitamin D", generic: "Vitamin D3 (Cholecalciferol)", strength: "1000 IU" },
  { brand: "Vitamin D3", generic: "Vitamin D3 (Cholecalciferol)", strength: "1000 IU" },
  { brand: "Osteocare", generic: "Calcium + Vitamin D3", strength: "500mg/200IU" },
  { brand: "Calcit", generic: "Calcium Carbonate", strength: "500mg" },
  { brand: "Caltrate", generic: "Calcium Carbonate", strength: "600mg" },
  { brand: "Vitamin C", generic: "Ascorbic Acid", strength: "500mg" },
  { brand: "Celin", generic: "Ascorbic Acid", strength: "500mg" },
  { brand: "Becosule", generic: "Vitamin B-Complex", strength: "" },
  { brand: "Vibex", generic: "Vitamin B-Complex", strength: "" },
  { brand: "Neurobion", generic: "Vitamin B1+B6+B12", strength: "" },
  { brand: "Zinc", generic: "Zinc Sulfate", strength: "20mg" },
  { brand: "Zincovit", generic: "Zinc + Multivitamin", strength: "20mg" },
  { brand: "Folic Acid", generic: "Folic Acid", strength: "5mg" },
  { brand: "Ferrous", generic: "Ferrous Sulfate", strength: "200mg" },
  { brand: "Iberet", generic: "Ferrous Sulfate + Vitamin C", strength: "150mg" },
  { brand: "Gastrex", generic: "Ranitidine", strength: "150mg" },
  { brand: "Rantac", generic: "Ranitidine", strength: "150mg" },
  { brand: "Tofnil", generic: "Imipramine", strength: "25mg" },
  { brand: "Warfin", generic: "Warfarin", strength: "5mg" },
  { brand: "Coumadin", generic: "Warfarin", strength: "5mg" },
  { brand: "Insulin Mixtard", generic: "Insulin (70/30 Mix)", strength: "100 IU/mL" },
  { brand: "Insulin Actrapid", generic: "Insulin Regular", strength: "100 IU/mL" },
  { brand: "Lantus", generic: "Insulin Glargine", strength: "100 IU/mL" },
  { brand: "Humulin", generic: "Insulin Regular", strength: "100 IU/mL" },
  { brand: "Montair", generic: "Montelukast", strength: "10mg" },
  { brand: "Montek", generic: "Montelukast", strength: "10mg" },
  { brand: "Singulair", generic: "Montelukast", strength: "10mg" },
  { brand: "Aerolin", generic: "Salbutamol", strength: "2mg" },
  { brand: "Ventolin", generic: "Salbutamol", strength: "2mg" },
  { brand: "Theo", generic: "Theophylline", strength: "100mg" },
  { brand: "Deriphyllin", generic: "Theophylline + Etofylline", strength: "23mg/77mg" },
  { brand: "Omacor", generic: "Omega-3 Fatty Acids", strength: "1000mg" },
  { brand: "Orocal", generic: "Calcium + Vitamin D", strength: "500mg/200IU" },
  { brand: "Glucosamine", generic: "Glucosamine Sulfate", strength: "500mg" },
  { brand: "Rabexa", generic: "Rabeprazole", strength: "20mg" },
  { brand: "Rabel", generic: "Rabeprazole", strength: "20mg" },
  { brand: "Acitrom", generic: "Acenocoumarol", strength: "1mg" },
  { brand: "Clindamycin", generic: "Clindamycin", strength: "300mg" },
  { brand: "Dalacin", generic: "Clindamycin", strength: "300mg" },
  { brand: "Levoflox", generic: "Levofloxacin", strength: "500mg" },
  { brand: "Levocin", generic: "Levofloxacin", strength: "500mg" },
  { brand: "Tavanic", generic: "Levofloxacin", strength: "500mg" },
];

export function searchMedicines(query: string): MedicineSuggestion[] {
  if (!query || query.length < 2) return [];
  const q = query.toLowerCase().trim();
  const results: MedicineSuggestion[] = [];
  const seen = new Set<string>();
  for (const med of medicineDb) {
    const key = `${med.brand}-${med.generic}-${med.strength}`;
    if (seen.has(key)) continue;
    const brandMatch = med.brand.toLowerCase().startsWith(q);
    const genericMatch = med.generic.toLowerCase().startsWith(q);
    const brandContains = med.brand.toLowerCase().includes(q);
    if (brandMatch || genericMatch) {
      results.unshift(med);
      seen.add(key);
    } else if (brandContains) {
      results.push(med);
      seen.add(key);
    }
    if (results.length >= 7) break;
  }
  return results.slice(0, 7);
}
